import React from 'react';
import { TFunction } from 'i18next';

// assets
import RedXIcon from 'demoRegistration/assets/red-x.svg?react';

// styles
import * as Styled from 'demoRegistration/styles/RegistrationFormSubmitted.style';
import * as Text from 'theme/components/Text.style';
import { Link } from '@mui/material';
import { Trans } from 'react-i18next';

interface RegistrationErrorProps {
  t: TFunction;
}

const RegistrationError: React.FC<RegistrationErrorProps> = ({ t }) => {
  // Helper function to safely cast translation results
  const translate = (key: string): string => t(key) as unknown as string;

  return (
    <Styled.Section>
      <Styled.ErrorCard>
        <RedXIcon />
        <Text.H3>{translate('Sorry, something went wrong!')}</Text.H3>
        <Text.P3>
          <Trans
            i18nKey="reachUsError"
            components={[
              <Link key="0" href="mailto:info@nurau.com" underline="none" />,
            ]}
            ns="pageDemoRegistration"
          />
        </Text.P3>
      </Styled.ErrorCard>
    </Styled.Section>
  );
};

export default RegistrationError;
